export default __webpack_public_path__ + "static/media/day.c33ef664.svg";